import { string } from 'yup';

export const shippingAddressSchema = string()
  .nullable() // for handling null value when clearing options via clicking "x"
  .required('Please fill out this field')
  .max(150, 'No more than 150 characters');
